<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 15.986 11.921"
  >
    <path
      id="Icon_awesome-check"
      data-name="Icon awesome-check"
      d="M5.429,16.264l-5.2-5.2a.8.8,0,0,1,0-1.13l1.13-1.13a.8.8,0,0,1,1.13,0l3.5,3.5,7.5-7.5a.8.8,0,0,1,1.13,0l1.13,1.13a.8.8,0,0,1,0,1.13L6.56,16.264A.8.8,0,0,1,5.429,16.264Z"
      transform="translate(0 -4.577)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-4'
    },
    height: {
      type: String,
      default: 'h-3'
    }
  }
}
</script>
